<template>
  <div class="wrap-deposit">
    <div class="title">
      <h3>KINESIS MONETARY INDONESIA - DEPOSIT CONFIRMATION</h3>
      <div>Manifest ID : KMI - 000001</div>
    </div>
    <div class="detail-deposit">
      <!-- <div class="date-deposit">Deposit Date : 2022-12-28 (ASIA/BATAM)</div> -->
      <div>Account Information :</div>
      <div>Kinesis Cayman</div>
      <div>Kinesis Cayman</div>
      <div>{{ dataDownload.depositor }}</div>
    </div>
    <table>
      <thead>
        <th>Metal</th>
        <th>Item Description</th>
        <th>Hallmark</th>
        <th>Serial Number</th>
        <th>Weight (gr)</th>
        <th>Fineness</th>
        <th>Quantity</th>
        <th>Deposit Date</th>
      </thead>
      <tbody>
        <tr v-for="(deposit, i) in dataDeposit" :key="i">
          <td>{{ deposit.metal_type }}</td>
          <td>{{ deposit.item_description }}</td>
          <td>{{ deposit.hallmark }}</td>
          <td>{{ deposit.serial_number }}</td>
          <td>{{ deposit.weight }}</td>
          <td>{{ deposit.fineness }}</td>
          <!-- <td>{{ deposit.quantity }}</td> -->
          <td>1</td>
          <td>{{ deposit.metal_date | formatIso }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dataDeposit: [],
    };
  },
  props: {
    dataDownload: {
      type: Object,
    },
  },
  mounted() {
    this.$emit("loadingStatus", false);
    axios
      .get(
        "/v2/clearing/admin/abx/get/detail/summary_inventory?startDate=" +
          this.dataDownload.startDate +
          "&endDate=" +
          this.dataDownload.endDate +
          "&limit&offset&type=download&depositor=" +
          this.dataDownload.depositor
      )
      .then((res) => {
        this.dataDeposit = res.data.data.body;
      });
  },
};
</script>

<style scoped>
.title {
  border-bottom: 2px solid #000;
  padding: 1rem 0;
  margin-bottom: 1rem;
}

.detail-deposit {
  margin-bottom: 2rem;
}

.date-deposit {
  margin-bottom: 0.5rem;
}
</style>
